/* Clever Hide links (Netpeak SEO recommendation, Sept 2026).
 *
 * Renders a clickable element that behaves like a link for people but is
 * not an <a href> for crawlers, so the target URL is not discovered or
 * crawled. Used for the product document PDFs (snippets/
 * product-documents-list.liquid) — the files already carry
 * `X-Robots-Tag: none` from Shopify's CDN, this just stops bots spending
 * crawl budget on them.
 *
 * Markup contract:
 *   <span class="clever-link" role="link" tabindex="0" data-link="<url>"
 *         data-target="_blank|_self">label</span>
 *
 * Clicks, middle-clicks and Enter / Space open `data-link` (new tab by
 * default). One delegated listener serves every .clever-link on the page,
 * including ones injected later by the Section Rendering API, so the
 * script is safe to include from more than one snippet.
 */
(() => {
  if (window.cleverLinkReady) return;
  window.cleverLinkReady = true;

  const open = (el, forceNewTab = false) => {
    const url = el.dataset.link;
    if (!url) return;
    const target = forceNewTab ? '_blank' : el.dataset.target || '_blank';
    if (target === '_self') {
      window.location.assign(url);
      return;
    }
    const win = window.open(url, target, 'noopener');
    if (win) win.opener = null;
  };

  const closest = (event) => event.target instanceof Element && event.target.closest('.clever-link');

  document.addEventListener('click', (event) => {
    const el = closest(event);
    if (!el) return;
    event.preventDefault();
    open(el, event.ctrlKey || event.metaKey);
  });

  // Middle mouse button — mirrors an anchor's "open in new tab".
  document.addEventListener('auxclick', (event) => {
    if (event.button !== 1) return;
    const el = closest(event);
    if (!el) return;
    event.preventDefault();
    open(el, true);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const el = closest(event);
    if (!el || el !== event.target) return;
    event.preventDefault();
    open(el);
  });
})();
